import { EnvName } from './models/env-name.enum';
import { EnvironmentModel } from './models/environment.model';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: EnvironmentModel = {
  production: false,
  useMocks: false,
  envName: EnvName.DEV,
  apiHost: 'https://dev-api.pay.partners/api/v1/',
  recaptchaAPIUrl: 'https://www.google.com/recaptcha/api.js?render=',
  recaptchaSiteKey: '6Lcc8WwoAAAAAJ9UGwLGmGzrm3OCk9feCtGMmdhY',
  googleAnalyticsId: null,
  assetsHost: '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
